import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3946ef1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ReportListItem" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-end"
}
const _hoisted_3 = {
  key: 0,
  class: "text-sm font-semibold text-green-400"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, "Ф.И.О курьера: " + _toDisplayString(_ctx.item.fullName), 1),
    _createElementVNode("p", null, "Доставка: (" + _toDisplayString(_ctx.item.deliveryDeliveredCount) + " / " + _toDisplayString(_ctx.item.deliveryCount) + ")", 1),
    _createElementVNode("p", null, "Забор: (" + _toDisplayString(_ctx.item.takeTaken) + " / " + _toDisplayString(_ctx.item.takeCount) + ")", 1),
    _createElementVNode("p", null, "Заполненность авто: (" + _toDisplayString(_ctx.item.carOccupancy) + ")", 1),
    (_ctx.isCanComplete)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (Boolean(_ctx.item.closeDayCreatedAt))
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " День завершен (" + _toDisplayString(_ctx.item.closeDayCreatedAt) + ") ", 1))
            : (_openBlock(), _createBlock(_component_the_button, {
                key: 1,
                class: "primary small",
                loading: _ctx.completeLoading,
                disabled: _ctx.completeDisabled,
                onClick: _ctx.emitComplete
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createTextVNode(" Завершить день ")
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"]))
        ]))
      : _createCommentVNode("", true)
  ]))
}